// extracted by mini-css-extract-plugin
export var platforms = "game-module--platforms--2poF_";
export var downloads = "game-module--downloads--3RYu_";
export var component = "game-module--component--2f45A";
export var columns = "game-module--columns--1PioN";
export var buttons = "game-module--buttons--3TLyK";
export var gameplay = "game-module--gameplay--28mNX";
export var platform = "game-module--platform--1tmy1";
export var download = "game-module--download--11D1m";
export var content = "game-module--content--2zXqK";